var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',[_c('Marca'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 mb-xs-4"},[_c('Modelo')],1),_c('div',{staticClass:"col-md-4 mb-xs-4"},[_c('Cilindrada')],1)]),_c('div',{staticClass:"form-row"},[_c('Ano'),_c('Estado')],1),_c('BtnCotacao')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }